import React from 'react';
import {FormControl, InputLabel, MenuItem, Select} from '@material-ui/core';
import $ from 'jquery';
import './SelectInput.scss';

const SelectInput = ({label, id, name, value, options, handleChange, classes, disabled = false, error = false, onFocusOut = false, isValue = false, displayedField = false}) => (
    <div>
        <FormControl
            onClick={()=> $(`#${name}`).focus()}
            disabled={disabled}
            classes={{
                root: `root-formcontrol-select ${classes} ${disabled && 'disabled-select'} ${error && 'error'}`
            }}>
            <InputLabel
                classes={{
                    root: 'input-label',
                    shrink: 'shrinked'
                }}
                shrink={true}
                htmlFor="documentType">{label}</InputLabel>
            <Select
                onFocus={(e)=>$(e.target).closest('.root-formcontrol-select').addClass('focused-field')}
                onBlur={(e)=>{
                        $(e.target).closest('.root-formcontrol-select').removeClass('focused-field');
                }}
                classes={{
                    root: 'root-select',
                    selectMenu: 'selected'
                }}
                disableUnderline={true}
                className='document-type-select'
                value={value}
                onChange={handleChange}
                inputProps={{
                    name: name,
                    id: id,
                }}
            >
                { options.map((option, index)=>{
                    return (
                        <MenuItem key={index} classes={{root: 'menuItemDocument'}}
                                  value={isValue ? index : displayedField ? option[displayedField] : option.title}>{displayedField ? option[displayedField] : option.title}</MenuItem>
                    )
                })}
            </Select>
        </FormControl>
        {typeof error === 'string' && <div className="error-text">{error}</div>}
    </div>
);

export default SelectInput;


// WEBPACK FOOTER //
// ./src/components/Common/SelectInput/SelectInput.js